<template>
  <v-list nav color="primary">
    <v-list-item-group active-class="active-item" color="primary">
      <v-list-item
          v-for="(item, i) in isAuthenticated ? authLinks : links"
          :key="i"
          :to="item.link"
          exact-path
          color="white"
      >
        <v-list-item-icon>
          <div v-if="item.isImage" style="height: 1em; width: 1em">
            <v-img :src="item.icon" style="contain: inherit"/>
          </div>
          <v-icon v-else color="white" style="width: 1em" size="large">{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="text-uppercase" style="color: white" v-text="item.text"/>
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>
  </v-list>
</template>
<script>
import { mapGetters } from "vuex";
import blogsIcon from "@/assets/blogs-icon.png";
import bookmarksIcon from "@/assets/bookmarks-icon.svg";

export default {
  name: "SideMenu",
  data: () => ({
    links: [
      {text: 'Home', link: '/home', icon: 'mdi-home-circle', isImage: false},
      {text: 'Blogs', link: '/blogs', icon: blogsIcon, isImage: true},
      {text: 'Tags', link: '/blogs/tags', icon: 'mdi-tag-multiple', isImage: false},
      // {text: 'Popular', link: '/blogs/popular', icon: 'mdi-trending-up', isImage: false}
    ],
  }),
  computed: {
    ...mapGetters({
      isAuthenticated: "auth/GET_IS_AUTHENTICATED",
      user: "auth/GET_USER",
    }),
    fullName() {
      return this.user?.profile?.first_name && this.user?.profile?.last_name
        ? `${this.user.profile.first_name} ${this.user.profile.last_name}`
        : this.user?.email;
    },
    bottomNavLinks() {
      if (this.isAuthenticated ){
        return this.authLinks.filter(x => x.text !== "Blogs").filter(y =>  y.text !== "My Blogs" )
      } else return this.links.filter(link => link.text !== "Blogs")
    },
    authLinks() {
      const links = [
        {text: 'Home', link: '/home', icon: 'mdi-home-circle', isImage: false},
        {text: 'Blogs', link: '/blogs', icon: blogsIcon, isImage: true},
        {text: 'Tags', link: '/blogs/tags', icon: 'mdi-tag-multiple', isImage: false},
        // {text: 'Popular', link: '/blogs/popular', icon: 'mdi-trending-up', isImage: false},
        {text: 'Bookmarks', link: '/blogs/bookmarks', icon: bookmarksIcon, isImage: true},
      ];

      if (this.user.account_types?.filter((item) => item.name === "MENTOR").length) {
        links.push({
          text: "My Blogs",
          link: "/blogs/my_blogs",
          icon: blogsIcon,
          isImage: true,
        });
      }
      return links;
    },
  },
};
</script>

<style lang="scss" scoped>
.active-item {
  background-color: rgba(79, 132, 255, 0.58);
  border-radius: .4em;
}

.v-list-item:hover {
  background-color: rgba(79, 132, 255, 0.58);
}
</style>

